<template>
  <div class="not-found-page">
    <div class="brand-chip">
      <img src="@/assets/img/epump_white_logo.svg" alt="ePump" />
    </div>
    <div class="not-found-card">
      <div class="code">404</div>
      <h1>Page not found</h1>
      <p>The page you requested does not exist or has been moved.</p>
      <button type="button" class="back-btn" @click="goBack">Go back</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: "login" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.not-found-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at top, rgba(252, 180, 0, 0.12), transparent 28%),
    radial-gradient(circle at bottom right, rgba(55, 15, 112, 0.28), transparent 34%),
    linear-gradient(135deg, #1f0d3f 0%, #370f70 46%, #12081f 100%);
}

.not-found-page::before,
.not-found-page::after {
  content: "";
  position: absolute;
  border-radius: 999px;
  filter: blur(20px);
  opacity: 0.35;
  pointer-events: none;
}

.not-found-page::before {
  width: 180px;
  height: 180px;
  background: #fcb800;
  top: 7%;
  left: -30px;
}

.not-found-page::after {
  width: 240px;
  height: 240px;
  background: #ffffff;
  right: -70px;
  bottom: 5%;
}

.brand-chip {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 18px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.22);
}

.brand-chip img {
  display: block;
  width: 118px;
  max-width: 100%;
}

.not-found-card {
  position: relative;
  z-index: 1;
  width: min(560px, 100%);
  text-align: center;
  color: #fff;
  padding: 52px 36px;
  border-radius: 30px;
  background: rgba(16, 9, 33, 0.68);
  border: 1px solid rgba(252, 184, 0, 0.18);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.38);
  backdrop-filter: blur(14px);
}

.code {
  font-size: clamp(5rem, 18vw, 8rem);
  font-weight: 800;
  line-height: 1;
  color: #fcb800;
  margin-bottom: 12px;
  text-shadow: 0 8px 24px rgba(252, 184, 0, 0.18);
}

h1 {
  margin: 0 0 12px;
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  color: #fff;
}

p {
  margin: 0 auto 28px;
  max-width: 380px;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.6;
  font-size: 1rem;
}

.back-btn {
  border: 0;
  border-radius: 999px;
  padding: 14px 28px;
  font-weight: 700;
  color: #370f70;
  background: linear-gradient(135deg, #fcb800 0%, #ffd66b 100%);
  box-shadow: 0 12px 30px rgba(252, 184, 0, 0.3);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.back-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 34px rgba(252, 184, 0, 0.36);
}

.back-btn:active {
  transform: translateY(0);
}

@media (max-width: 576px) {
  .not-found-page {
    justify-content: flex-start;
    padding: 20px 16px;
    gap: 14px;
  }

  .brand-chip {
    margin-top: 18px;
    padding: 10px 14px;
  }

  .brand-chip img {
    width: 96px;
  }

  .not-found-card {
    width: 100%;
    padding: 34px 20px 30px;
    border-radius: 24px;
  }

  .code {
    margin-bottom: 8px;
  }

  h1 {
    font-size: 1.7rem;
  }

  p {
    max-width: 100%;
    margin-bottom: 22px;
    font-size: 0.96rem;
  }

  .back-btn {
    width: 100%;
    padding: 14px 18px;
  }
}
</style>
